import type { SalesInvoiceTabId } from "./types/salesInvoice";
import { TAB_LABELS, TAB_ORDER } from "./utils/salesInvoicesFormat";

interface Props {
    activeTab: SalesInvoiceTabId;
    counts: Record<SalesInvoiceTabId, number> | null;
    onChange: (tab: SalesInvoiceTabId) => void;
}

export function SalesInvoiceTabs({ activeTab, counts, onChange }: Props) {
    return (
        <div className="flex gap-6 border-b border-gray-200 overflow-x-auto">
            {TAB_ORDER.map((tab) => {
                const isActive = tab === activeTab;
                return (
                    <button
                        key={tab}
                        type="button"
                        onClick={() => onChange(tab)}
                        className={`pb-3 -mb-px flex items-center gap-1.5 text-sm font-medium whitespace-nowrap border-b-2 transition ${
                            isActive
                                ? "border-primary text-primary"
                                : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        {TAB_LABELS[tab]}
                        {counts !== null && (
                            <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                                {counts[tab]}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
